
import { genderToTagColor } from '@src/constants'
import Tag from '../Tag/Tag'

export default function GenderTag ({ children: gender, ...props }) {
  return <Tag {...props} color={genderToTagColor(gender)}>{gender}</Tag>
}
